import React from 'react'
import { MenuContainer } from '../../components/menuContainer/MenuContainer'
import { motion } from 'framer-motion'
import SecondCarousel from '../../components/carousel/SecondCarousel'
import styled from 'styled-components'

const WarehouseImg = styled.img`
  width: 900px;
  height: auto;
  object-fit: contain;

  @media (max-width: 991px) {
    width: 700px;
  }
  @media (max-width: 767px) {
    width: 500px;
  }
  @media (max-width: 575px) {
    width: 400px;
  }
  @media (max-width: 430px) {
    width: 300px;
  }
`

export const Distribution = () => {
  const options = { align: 'start', dragFree: false, loop: true }

  return (
    <div>
      <MenuContainer title="사업소개" menu="물류 시설 현황" pointRadius="50%">
        <div style={{ textAlign: 'center' }}>
          <motion.div
            className="comment"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false }}
            transition={{
              ease: 'easeInOut',
              duration: 1,
              y: { duration: 0.5 },
            }}
          >
            "신뢰와 효율성을 보장하는 최첨단 물류 장비 솔루션"
          </motion.div>
          <motion.div
            className="detailed-comment"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false }}
            transition={{
              ease: 'easeInOut',
              duration: 1,
              y: { duration: 0.5 },
            }}
          >
            정직과 정도 경영을 바탕으로 고객의 요구를 충족하며,
            <br />
            혁신과 효율성으로 경쟁력을 확보하고 물류 산업을 선도하겠습니다.
          </motion.div>
        </div>
      </MenuContainer>
      <SecondCarousel options={options} />
      <div style={{ textAlign: 'center', margin: '145px 0 60px 0' }}>
        <b
          style={{
            color: 'var(--bs-primary)',
            fontSize: '34px',
          }}
        >
          창고 배치도
        </b>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '250px',
        }}
      >
        <WarehouseImg src="/warehouse-layout.png" alt="창고 배치도" />
      </div>
    </div>
  )
}
